module.exports = __webpack_public_path__ + "static/img/dyg.db68c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/dyg.png
// module id = ydwo
// module chunks = 0